import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  List,
  useListRepository,
  DatePicker,
  useFilter,
  Filter,
  TextField
} from 'elentari'
import Snackbar from '../../components/CustomSnackbar'
import logFlexRepository from './logFlexRepository'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import moment from 'moment'
import CentroCustoAutocomplete from '../CentrosCusto/CentroCustoAutocomplete'
import * as R from 'ramda'
import { downloadCsv } from '../../utils/DownloadCsv'
import { useLocation } from 'react-router-dom'

const LogFlexFilter = () => {
  const filter = useFilter({})

  return (
    <Filter {...filter} labels={{ find: 'Buscar', clear: 'Limpar' }}>
      <Grid container spacing={3}>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="dataInicio"
            label="Data Início"
            component={DatePicker}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="dataFim"
            label="Data Fim"
            component={DatePicker}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="consulta"
            label="Consulta"
            component={TextField}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="centroCustoId"
            label="Centro de custo"
            component={CentroCustoAutocomplete}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const LogFlex = ({ classes, history, ...props }) => {
  const [mensagem, setMensagem] = useState('')
  const location = useLocation()
  const [ability] = useAbility()

  const listOptions = {
    defaultOrder: 'id desc',
    fields: {
      solicitacaoId: {
        label: 'Solicitação',
        format: value => `#${value}`
      },
      data: {
        label: 'Data',
        format: data => moment(data).format('DD/MM/YYYY HH:mm:ss')
      },
      consulta: {
        label: 'Consulta'
      },
      centroCusto: {
        label: 'Centro Custo'
      },
      empresa: {
        label: 'Empresa'
      }
    }
  }

  const listHook = useListRepository({
    repository: logFlexRepository,
    defaultSort: 'id desc',
    path: 'log-flex'
  })
  const actions = getListActions(ability, listHook, 'logFlex')

  const onDownloadClick = async () => {
    setMensagem('Preparando download')
    const params = new URLSearchParams(location.search)
    const { page, rows, sort = 'id desc', ...allQuery } = R.fromPairs([
      ...params.entries()
    ])
    const response = await logFlexRepository.list({
      query: {
        ...allQuery,
        ...(sort ? { sort } : {})
      }
    })
    if (response.ok) {
      const list = response.data
      await downloadCsv(list, listOptions, true, true, 'LogsFlex')
      setMensagem('')
    } else {
      setMensagem('Falha ao fazer download!')
    }
  }

  return (
    <>
      <LogFlexFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        onClickEdit={null}
        onClickNew={null}
        onClickView={null}
        onClickRow={item => history.push(`/solicitacoes/${item.solicitacaoId}`)}
        flatOnDownload
        csvSeparator=";"
        onDownloadClick={onDownloadClick}
        removeItem={null}
        listOptions={listOptions}
      />
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
    </>
  )
}

export default LogFlex
